import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, Subject } from 'rxjs';
import { withCache, HttpCacheManager } from '@ngneat/cashew';

import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AvatarService {
  private http = inject(HttpClient);
  private manager = inject(HttpCacheManager);

  private avatarServiceUrl = `${environment.apiUrl}/api/avatar`;
  private avatarSource = new Subject<string>();

  avatar$ = this.avatarSource.asObservable();

  public getUserAvatarUrl(userId: string): Observable<string> {
    return this.http.get(`${this.avatarServiceUrl}/${userId}`, {
      ...withCache(),
      responseType: 'text',
    });
  }

  public uploadAvatar(image: File, partName = 'image'): Observable<void> {
    const formData = new FormData();
    formData.append(partName, image);
    return this.http.post<void>(this.avatarServiceUrl, formData);
  }

  notifyAvatar(userId: string) {
    this.manager.delete(`${this.avatarServiceUrl}/${userId}`);
    this.avatarSource.next(userId);
  }
}
